export class ValidationError extends Error {
  public readonly validationErrors: { errors: string[]; invalid: boolean }[];

  constructor(validationErrors: { errors: string[]; invalid: boolean }[]) {
    super('');

    this.validationErrors = validationErrors;
    this.name = 'ValidationError';

    Object.setPrototypeOf(this, ValidationError.prototype);
  }
}
